module.exports = __webpack_public_path__ + "static/truck-46435513e3ae9d76a454fc7ff9755253.jpg";